import { createStyles, makeStyles } from "@mui/styles";
import { CommonFonts, Colors } from "@/theme";

const useStyles = makeStyles((theme) =>
  createStyles({
    regionalText: {
      ...CommonFonts.darkBoldFont30,
      fontSize: 34,
      letterSpacing: 0.28,
      [theme.breakpoints.down("sm")]: {
        fontSize: 20,
      },
    },
    addSalesButton: {
      "&.MuiButton-root": {
        fontSize: 16,
        fontWeight: "bold",
        textTransform: "none",
      },
    },
  })
);

export default useStyles;
